import { render, staticRenderFns } from "./Tablet.vue?vue&type=template&id=4f83b2e0&scoped=true&"
import script from "./Tablet.vue?vue&type=script&lang=js&"
export * from "./Tablet.vue?vue&type=script&lang=js&"
import style0 from "./Tablet.vue?vue&type=style&index=0&id=4f83b2e0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83b2e0",
  null
  
)

export default component.exports